import { createActionCreator } from '../../utils/helpers';

import {
  deleteFundingReport,
  deleteFundingReportNewHub,
  CLOSE_DELETE_FUNDING_REPORT_MODAL,
  OPEN_DELETE_FUNDING_REPORT_MODAL,
} from './types';

export const requestDeleteFundingReport = createActionCreator(
  deleteFundingReport.request,
  'reportId',
);
export const requestDeleteFundingReportNewHub = createActionCreator(
  deleteFundingReportNewHub.request,
  'reportId',
);
export const requestDeleteFundingReportSuccess = createActionCreator(
  deleteFundingReport.success,
  'reportId',
);
export const requestDeleteFundingReportFailure = createActionCreator(deleteFundingReport.failure);

export const openDeleteFundingReportModal = createActionCreator(
  OPEN_DELETE_FUNDING_REPORT_MODAL,
  'fundingReport',
);
export const closeDeleteFundingReportModal = createActionCreator(CLOSE_DELETE_FUNDING_REPORT_MODAL);
